__turbopack_context__.v({
  "countdown": "countdown-campaign-module__q80pva__countdown",
  "countdown__card": "countdown-campaign-module__q80pva__countdown__card",
  "countdown__close": "countdown-campaign-module__q80pva__countdown__close",
  "countdown__copy": "countdown-campaign-module__q80pva__countdown__copy",
  "countdown__inner": "countdown-campaign-module__q80pva__countdown__inner",
  "countdown__label": "countdown-campaign-module__q80pva__countdown__label",
  "countdown__petal": "countdown-campaign-module__q80pva__countdown__petal",
  "countdown__petals": "countdown-campaign-module__q80pva__countdown__petals",
  "countdown__shipping": "countdown-campaign-module__q80pva__countdown__shipping",
  "countdown__subtitle": "countdown-campaign-module__q80pva__countdown__subtitle",
  "countdown__timer": "countdown-campaign-module__q80pva__countdown__timer",
  "countdown__title": "countdown-campaign-module__q80pva__countdown__title",
  "countdown__value": "countdown-campaign-module__q80pva__countdown__value",
  "petalDrift": "countdown-campaign-module__q80pva__petalDrift",
});
